module.exports = __webpack_public_path__ + "assets/img/gk.61efe15c.png";